const SamplesChooseEl = document.querySelector('.SamplesSection__select-block');

if (SamplesChooseEl) {
  const samplesSelect = SamplesChooseEl.querySelector('[name="samplesSelect"]');

  samplesSelect.addEventListener('change', function () {
    SamplesChooseEl.querySelector('.Btn').setAttribute('href', this.value);
  });
}
